import { render, staticRenderFns } from "./LaunchpadButton.vue?vue&type=template&id=89876a10&scoped=true&"
import script from "./LaunchpadButton.vue?vue&type=script&lang=js&"
export * from "./LaunchpadButton.vue?vue&type=script&lang=js&"
import style0 from "./LaunchpadButton.vue?vue&type=style&index=0&id=89876a10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89876a10",
  null
  
)

export default component.exports